export default "__VITE_ASSET__khGzJHfe__"